import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GOOGLE_ANALYTICS_SETTINGS_TOKEN } from './constants';
import { IGoogleAnalyticsSettings } from './interfaces/IGoogleAnalyticsSettings';
import { GOOGLE_ANALYTICS_INITIALIZER_PROVIDER } from './providers/google-analytics.initializer';
import { GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER } from './providers/google-analytics-router.initializer';
import { GoogleAnalyticsModule } from './google-analytics.module';

/**
 * Google Analytics
 * 
 * 
 */

@NgModule({
  imports: [
    CommonModule,
    GoogleAnalyticsModule
  ],
  providers: [
      GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER
  ]
})
export class GoogleAnalyticsRouterModule { 
    
}
